import { EyeOutlined } from "@ant-design/icons";
import { Backdrop, CircularProgress } from "@mui/material";
import { Button, Col, Radio, Row, Table, TableProps } from "antd";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { GetPendingEmailTasks, GetPendingTasks, GetStatusTypes } from "../../../API/api";
import AdminLayout from "../../../component/AdminLayout";
import { customSortDirections } from "../../../Utils/utils";
import RejectComments from "../components/RejectComments";
import TaskDetails from "../components/TaskDetails";
import { SorterResult } from "antd/es/table/interface";
const options = [
  { label: 'Pending', value: '1' },
  { label: 'Approved', value: '2' },
  { label: 'Rejected', value: '3' },
];
const PendingTasks = () => {
  const [showTaskDetails,setShowTaskDetails] = useState<boolean>(false)
    const [currentPage,setCurrentPage] = useState<number>(1)
    const [taskDetails,setTaskDetails] = useState({})
    const [pendingTaskList,setPendingTaskList] = useState([])
    const [statusOptions,setStatusType] = useState([])
    const [showComments,setShowComments] = useState<boolean>(false)
    const [radioValue,setRadioValue] = useState<any>('1')
    const [sortedInfo, setSortedInfo] = useState<SorterResult<any>>({});
    const [pagesize,setPageSize] = useState<number>(50)

const onShowTaskDetails = (row:any) => { setTaskDetails(row); setShowTaskDetails(true)}
useEffect(()=>{
  fetchStatusTypes()
  fetchCombinedTasks()
},[])


useEffect(()=>{
  fetchCombinedTasks()

},[radioValue])
const fetchCombinedTasks = async () => {
  setIsLoading(true)
  // Use Promise.all to wait for both API calls to resolve
  const [emailResponse, approvalResponse] = await Promise.all([
    GetPendingTasks(radioValue),
    GetPendingEmailTasks(radioValue)
  ]);
  const emailData = emailResponse.data.map((approvals:any) => ({
    ...approvals,
    // key: approvals.licenseRequestId,
  }));

  const approvalData = approvalResponse.data.map((approvals:any) => ({
    ...approvals,
    // key: approvals.licenseRequestId,
  }));
  // Combine or process the data as needed
  const combinedData :any= [...emailData, ...approvalData];
 const hhh:any = combinedData.map((data:any,index:number) => ({
    ...data,
    key:index
  }))
  setPendingTaskList(hhh);
  setIsLoading(false)

}
const fetchStatusTypes = async () => {
  try {
    setIsLoading(true);
    const response = await GetStatusTypes();
    const newData = response.data.map((category: any, index: number) => ({
      ...category,
      key: category.statusId,
    }));
    setStatusType(newData);
    setIsLoading(false);
  } catch (error: any) {
    enqueueSnackbar(error, {
      variant: "error",
      anchorOrigin: {
        vertical: "top",
        horizontal: "right",
      },
    });
    setIsLoading(false);
  }
}

const onShowComments = (row:any) =>{setTaskDetails(row);setShowComments(true) } 
    const columns = [
        {
          title: "No",
          dataIndex: "id",
          key: "id",
          width:'10%',
          render: (text: any, record: any, index: number) =>
            (currentPage - 1) * pagesize + index + 1,
        },
        {
          title: "Task",
          dataIndex: "description",
          key: "description",
       
          render: (text: string) => <div>{text}</div>,
        },
          {
            title: "View Details",
           
            render: (_: any, record: any) => {
              return  (
                <>
                  {" "}
                  <Button style={{marginRight:'15px'}} type="link" onClick={() => onShowTaskDetails(record)}  icon={<EyeOutlined />} size="small" />

                  
                </>
              );
            },
           
          },
          // ...(radioValue === 3
          // ? [
        {
          title: "Comments",
          dataIndex: "action",
          render: (_: any, record: any) => {
            return  (
              <>
                {" "}
                <Button style={{marginRight:'15px'}} disabled={!record.comments} type="link" onClick={() => onShowComments(record)}  icon={<EyeOutlined />} size="small" />

                
              </>
            );
          },
        },
      // ]
      //   : []),
      ];
    const [isLoading,setIsLoading] = useState<boolean>(false)
    const handleChange = (row:any)=>{
      setRadioValue(Number(row.target.value))
    }
    const tablehandleChange: TableProps<any>["onChange"] = (
  
      pagination,
      filters,
      sorter
    ) => {
      setSortedInfo(sorter as SorterResult<any>);
      setCurrentPage(pagination.current || 1);
      setPageSize(pagination.pageSize ?? 50)
  
  
    };
    return  <>
    {" "}
    <AdminLayout>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme: any) => theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div>
        <div className="employee-table-header ">
        <Row gutter={16} style={{ alignItems: "center", margin: "12px 16px",justifyContent:'space-between'}}>
            <Col className="gutter-row" style={{ alignItems: "center", margin: "12px 16px"}}>
              <h3 className="bottom-margin-mob" style={{ float: "left" }}>
                Tasks
              </h3>
            </Col>
            <Col className="gutter-row pm-search-flex" xl={{span: 10, offset: 2}} lg={24} xs={24} style={{ display: "flex",justifyContent:'end'}} >
            <Radio.Group options={options} defaultValue='1'  onChange={handleChange} optionType="button">
     
    </Radio.Group>
           
            </Col>
          </Row>
        </div>

         <Table
          sortDirections={customSortDirections}
          className="status-list-admin"
          scroll={{ y: 500 }}
          onChange={tablehandleChange}

          columns={columns}
          size='small'
          pagination={{
            current: currentPage,
            showSizeChanger: true,
            defaultPageSize: 50,
          }}
          tableLayout="fixed"
          rowClassName="editable-row"
          dataSource={pendingTaskList}

        />
      </div>
   
    </AdminLayout>
    {showTaskDetails && <TaskDetails onClosePopup={() => setShowTaskDetails(false)} taskDetails={taskDetails}/>}
    {showComments && <RejectComments onClosePopup={() => setShowComments(false)} taskDetails={taskDetails}/>}
  </>
}

export default PendingTasks;